import useApiRequest from 'api/useApiRequest';
import { fetchCrmInteractionDateHistogram, fetchCrmInteractionQuery } from 'api/services/crmInteractionService';

const useCrmInteraction = () => {
  const { request } = useApiRequest();

  const getCrmInteractionDateHistogram = async (params) => {
    const { data } = await fetchCrmInteractionDateHistogram(request, params);
    return data;
  };

  const queryCrmInteractions = async (params) => {
    const { data } = await fetchCrmInteractionQuery(request, params);
    return data;
  };

  return { getCrmInteractionDateHistogram, queryCrmInteractions };
};

export default useCrmInteraction;
